import { useQuery } from '@tanstack/react-query';
import { searchAcrossApplication } from '@/api/globalSearch';

/**
 * Fetches global search results across the application for the given search term.
 * @param search - Raw search input; whitespace is trimmed before querying.
 * @param enabled - Whether the query is allowed to run (e.g. search UI is open).
 * @returns TanStack Query result containing the matching search results.
 */
export function useGlobalSearchResults(search: string, enabled: boolean) {
  const normalizedSearch = search.trim();

  return useQuery({
    queryKey: ['global-search', normalizedSearch],
    queryFn: () => searchAcrossApplication(normalizedSearch),
    // Avoid firing search requests for very short terms (noisy/low-value results).
    enabled: enabled && normalizedSearch.length >= 2,
    staleTime: 30_000,
  });
}
